// extracted by mini-css-extract-plugin
module.exports = {"footer":"MatchingPreferenceFooter_footer__hblZo","buttonRow":"MatchingPreferenceFooter_buttonRow__5jfSz"};